<template>
  <div id="app" :class="[constant.imgSrc == 'theme1' ? 'account-theme' : 'history-theme']"
    :style="{ '--minWidth': minWidth }" @contextmenu.prevent>
    <vuescroll id="outter-scroll" ref="outter-scroll" :ops="scrollOps">
      <keep-alive-router :level="1"></keep-alive-router>
    </vuescroll>
    <!--遮罩-->
    <div v-if="URL_ARRAY.length !== 0"
      style="position: absolute;left: 0;top:0;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);z-index: 9999">
      <div><img :src="require('@/assets/images/' + theme.imgSrc + '/common/loading_iSpt.png')"
          style="position: absolute;right: 44%;top: 35%;width: 180px;height: 180px;z-index: 9999"></div>
    </div>
    <div v-if="URL_ARRAY_ENDLESSON.length !== 0"
      style="position: absolute;left: 0;top:0;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);z-index: 9999">
      <div><img :src="require('@/assets/images/' + theme.imgSrc + '/common/historyDataBg.png')"
          style="position: absolute;right: 44%;top: 35%;width: 180px;height: 180px;z-index: 9999"></div>
    </div>
    <entrance />
    <ai-assistant v-if="isLoginPage"> </ai-assistant>
  </div>
</template>
<script>
import "@/assets/font/iconfont.css";
import "@/assets/iconfont/iconfont.css";
import { URL_ARRAY, URL_ARRAY_ENDLESSON } from "./components/tools/request/https.js";
import vuescroll from 'vuescroll';
import { mapMutations, mapState } from "vuex";
import Entrance from "./components/common/entrance";
import storage from "./components/tools/storage";
import { themeMixins } from "./components/common/mixins/themeMixins";
import keepAliveRouter from "@/components/common/keep-alive-router";
import aiAssistant from "@/components/common/aiAssistant";
export default {
  name: "App",
  mixins: [themeMixins],
  data () {
    return {
      scrollOps: {
        bar: {
          background: '#6ce3fd',
          opacity: 0.8,
          onlyShowBarOnScroll: true,
          keepShow: false,
          size: '6px',
          minSize: 0.3,
        },
      },
      URL_ARRAY: URL_ARRAY,
      URL_ARRAY_ENDLESSON: URL_ARRAY_ENDLESSON,
      courseType: '',
      minWidth: '',
      isLoginPage: true
    }
  },
  components: { vuescroll, Entrance, keepAliveRouter, aiAssistant },
  computed: {
    ...mapState({
      theme: state => state.theme.themeData
    })
  },
  methods: {
    ...mapMutations({
      setThemeData: 'setThemeData'
    }),
    // 修改滚动条高度
    setOutterScrollY (paramY) {
      if (!paramY) {
        paramY = 0;
      }
      this.$refs['outter-scroll'].scrollTo({ y: paramY }, 100);
    },
    // 返回顶部
    goTop () {
      this.$refs['outter-scroll'].scrollTo({ y: 0 }, 500);
    },
    // 初始化element主题
    initElementUi () {
      let color = ''
      if (storage.getUserInfo() && storage.getUserInfo().loginNo === 'taradmin') {
        color = '#FC6D00'
      } else {
        color = this.theme.imgSrc === 'theme1' ? '#4B54DE' : '#AE3524';
      }
      this.themeColor = color
    }
  },
  watch: {
    $route (newValue, oldValue) {
      if (newValue.fullPath.includes('review')) {
        this.$store.state.theme.themeData.imgSrc = 'theme1'
        this.constant.imgSrc = 'theme1'
        this.themeColor = '#4B54DE'
      } else {
        this.$store.state.theme.themeData = (sessionStorage.getItem('default-theme') && JSON.parse(sessionStorage.getItem('default-theme'))) || 'theme1'
        this.constant.imgSrc = this.theme.imgSrc;
        this.initElementUi()

      }
      if (storage.getUserInfo()) {
        this.isLoginPage = true
      } else {
        this.isLoginPage = false
      }
    }
  },
  created () {
    import("./assets/scss/theme/account/account.scss");
    import("./assets/scss/theme/history/history.scss")
    this.constant.imgSrc = this.theme.imgSrc;
    // 判断是否是手机端
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    this.minWidth = flag ? '' : '1360px';
  },
  mounted () {
    this.initElementUi()
  },
  provide () {
    return {
      goTopOutter: this.goTop,
      initElementUi: this.initElementUi
    }
  },
};
</script>
<style>
#app>div.__vuescroll>div.__panel>div.__view {
  width: 100% !important;
  min-width: var(--minWidth) !important;
  height: 100%;
}

#app>div.__vuescroll>div.__panel>div.__view>div {
  min-height: 100%;
}

#app div.__view {
  height: 100%;
}

.w-e-modal {
  width: 880px !important;
  position: fixed;
  top: 15% !important;
  left: 26% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue